// Variant spread toggle: persists the shopper's choice as the showVariants
// cart attribute (survives navigation, readable server-side), then reloads so
// Liquid re-renders the grid. Shared by the collection grid and search results.
//
// The attribute write reuses saveCollectionview() from theme.js (the same
// mechanism the grid view switcher uses); it returns the fetch promise so the
// reload only happens once the attribute is saved.
//
// The value is always written explicitly as 'true' or 'false'. An empty string
// deletes the attribute, which would be read back as "no choice made" and fall
// through to the theme's default - so it can never stand in for "on".
(function () {
	function bind() {
		document.querySelectorAll('.variant-spread-toggle input').forEach(function (toggle) {
			if (toggle.dataset.variantSpreadBound === 'true') return;
			toggle.dataset.variantSpreadBound = 'true';

			toggle.addEventListener('change', function () {
				toggle.disabled = true;

				// Dim the grid while the attribute saves and the page reloads.
				var grid = document.getElementById('collection');
				if (grid) grid.classList.add('variant-spread-loading');

				saveCollectionview('showVariants', toggle.checked ? 'true' : 'false')
					.then(function () {
						window.location.reload();
					})
					.catch(function (error) {
						console.error('Variant spread toggle failed:', error);
						// Nothing was saved and we are not reloading, so put the
						// switch back where it was rather than leave it showing a
						// state the server does not have.
						toggle.checked = !toggle.checked;
						toggle.disabled = false;
						if (grid) grid.classList.remove('variant-spread-loading');
					});
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bind);
	} else {
		bind();
	}
})();
